import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const CountDown = (props) => {
  const [state, setState] = useState({
    endTime: moment(props.startTime).add(2, 'm').format(),
    currentTime: moment().format(),
  });

  const onStopCountDown = () => {
    props.onStopCountDown();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setState({ ...state, currentTime: moment().format() });
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  useEffect(() => {
    if (moment(state.endTime).format() === state.currentTime) {
      onStopCountDown();
    }
  }, [state.currentTime]);
  return (
    <>
      (
      {moment.utc(moment(state.endTime, 'HH:mm:ss').diff(moment(state.currentTime, 'HH:mm:ss'))).format('mm:ss')}
      )
    </>
  );
};

CountDown.defaultProps = {
  startTime: '',

  onStopCountDown: () => {},
};

CountDown.propTypes = {
  startTime: PropTypes.string,

  onStopCountDown: PropTypes.func,
};

export default CountDown;
